import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import DButton from "discourse/components/d-button";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { i18n } from "discourse-i18n";
import Circle from "../../models/circle";
import CirclesMembershipReasonModal from "../modal/membership-reason";

export default class CirclesMembershipPostRequest extends Component {
  @service siteSettings;
  @service store;
  @service modal;

  @tracked handled = false;

  @action
  async acceptRequest() {
    try {
      await Circle.handleMembershipRequest(this.args.circleCategoryId, {
        user_id: this.args.userId,
        accept: true,
      });
      this.handled = true;
    } catch (e) {
      popupAjaxError(e);
    }
  }

  @action
  async denyRequest() {
    const performDeny = async (reason) => {
      try {
        await Circle.handleMembershipRequest(this.args.circleCategoryId, {
          user_id: this.args.userId,
          accept: false,
          reason,
        });

        this.handled = true;
      } catch (e) {
        popupAjaxError(e);
      }
    };

    if (this.siteSettings.discourse_circles_ask_reason_when_denying_request) {
      const circle = await this.store.find(
        "circle",
        this.args.circleCategoryId
      );

      this.modal.show(CirclesMembershipReasonModal, {
        model: {
          circle,
          // because controllers are singletons. ensures that the reason will
          // be empty
          reason: "",
          mode: "deny",
          onSubmit: performDeny,
        },
      });
    } else {
      return await performDeny();
    }
  }

  <template>
    {{#unless this.handled}}
      <div class="circles-membership-request-handle-bar">
        <DButton
          @action={{fn this.acceptRequest @post.username}}
          @label="discourse_circles.circle.requests.accept"
          class="btn-primary"
        />
        <DButton
          @action={{fn this.denyRequest @post.username}}
          @label="discourse_circles.circle.requests.deny"
          class="btn-danger"
        />
        <LinkTo
          @route="circle.requests"
          @model={{@circleCategoryId}}
          class="btn btn-default"
        >
          {{i18n "discourse_circles.circle.membership_request.handle"}}
        </LinkTo>
      </div>
    {{/unless}}
  </template>
}
